import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table, Image, Button, Icon } from "semantic-ui-react";
import _ from "lodash";
import cx from "classnames";
import styles from "./workspaces.module.scss";
import { fetchCleverstoryWorkspaces } from "actions/cleverstory";
import CreateWorkspace from "./CreateWorkspace";


export default function Workspaces({
  account,
  setLoading,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [updateWorkspace, setUpdateWorkspace] = useState(null);
  const [updateWorkspaceOpen, setUpdateWorkspaceOpen] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const workspaces = useSelector((state) => _.get(state, "cleverstoryWorkspace.items.records",[]));
  const loading = useSelector((state) => _.get(state, "cleverstoryWorkspace.loading"));

  useEffect(() => {
    setLoading(loading);
  }, [loading]);


  useEffect(() => {
    if (!loading && account) {
      dispatch(fetchCleverstoryWorkspaces({account: account.id.toString()}));
    }
  }, []);


  setTimeout(
    function() {
      setInitialRender(false);
    },
    [3000]
  );

  const handleClick = (item) => {
    history.push({
      pathname: `/paperflite/accounts/${account.id}/cleverstory/${item.id}`,
      state: { accountId: account.id, workspaceId: item.id },
    });
  };

  const handleEdit = (workspace) => {
    setUpdateWorkspace(workspace);
    setUpdateWorkspaceOpen(true);
  }

  return (
    <>
        <Table singleLine className={cx(styles.table)}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                NAME
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                DESCRIPTION
              </Table.HeaderCell>
              <Table.HeaderCell width={1} className={cx(styles.header)}>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body className={cx(styles.body)}>
            {!loading && workspaces.length === 0 && (
              <>
                <Table.Row>
                  <Table.Cell colSpan="5" className={cx(styles.cell)}>
                    <div className={cx(styles.noData)}>
                      No Workspace
                    </div>
                  </Table.Cell>
                </Table.Row>
              </>
            )}

            {loading && workspaces.length === 0 && (
              <>
                <Table.Row>
                  <Table.Cell colSpan="5" className={cx(styles.cell)}>
                    <div className={cx(styles.noData)}>
                      Loading
                      <Icon name="sync" loading className={cx(styles.icon)} />
                    </div>
                  </Table.Cell>
                </Table.Row>
              </>
            )}

            {workspaces.length !== 0 && (
              <>
                {workspaces.map((item, idx) => (
                  <>
                    <Table.Row key={idx}>
                      <Table.Cell width={3} className={cx(styles.cell)}>
                        <div
                          className={cx(styles.text, styles.pointer)}
                          onClick={() => handleClick(item)}
                        >
                          {item.name}
                        </div>
                      </Table.Cell>
                      <Table.Cell width={3} className={cx(styles.cell)}>
                        <div className={cx(styles.text)}>{item.description}</div>
                      </Table.Cell>
                      <Table.Cell width={1} className={cx(styles.cell)}>
                        <div className={styles.actions}>
                          <div
                            className={styles.actionIcons}
                            onClick={() => handleEdit(item)}
                          >
                            <Icon name="edit outline" />
                            <span>Edit</span>
                          </div>
                        </div>
                    </Table.Cell>
                    </Table.Row>
                  </>
                ))}
              </>
            )}
          </Table.Body>
        </Table>
        <CreateWorkspace
          account={account}
          open={updateWorkspaceOpen}
          setOpen={setUpdateWorkspaceOpen}
          workspace={updateWorkspace}
        />
    </>
  );
}
